// API base domain
const base_domain = process.env.API_BASE_URL;
export default base_domain;
